import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
export default history;



// WEBPACK FOOTER //
// ./src/history.ts